import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ListView, ListViewColType, ListViewField, ListViewSort, ListViewSortMode } from '../../model/list-view';

@Component({
    selector: 'zx-list-view-th',
    templateUrl: './list-view-th.component.html',
    styleUrls: ['./list-view-th.component.css'],
})
export class ListViewThComponent {

    private _listView: ListView;
    private _sortIncreaseIndex = 0;

    @Input() field: ListViewField;
    @Input() type: ListViewColType | string = ListViewColType.FIELD;
    @Input() customContent: boolean = false;
    @Output() sortChange: EventEmitter<ListViewField> = new EventEmitter();
    @Output() filterChange: EventEmitter<ListViewField> = new EventEmitter();

    constructor() { }

    @Input() set listView(listView: ListView) {
        this._listView = listView;
    }
    get listView(): ListView {
        return this.field != null && this.field.listView != null ? this.field.listView : this._listView;
    }

    toggleFieldSorter(){
        if(this.field.sort && this.field.sort.enabled){
            if(this.field.sort.value == "asc") this.field.sort.value = "desc";
            else this.field.sort.value = "asc";
            this.onSortChange();
        }
    }

    onSortChange() {
        // console.log(this.field);
        if (this.listView.sortMode == null || this.listView.sortMode == ListViewSortMode.SINGLE) {
            const fields = this.listView.fields;
            let fieldSort: ListViewSort;
            Object.keys(fields).forEach(key => {
                if (fields[key].sort && key != this.field.name) {
                    fieldSort = fields[key].sort;
                    if (fieldSort.sortIndex && fieldSort.sortIndex > this._sortIncreaseIndex) {
                        this._sortIncreaseIndex = fieldSort.sortIndex;
                    }
                    fieldSort.value = null;
                    fieldSort.sortIndex = null;
                }
            });
        }
        if (this.field.sort && this.field.sort.enabled && this.field.sort.value != null) {
            this.field.sort.sortIndex = this._sortIncreaseIndex++;
        }
        // 触发当前字段事件
        this.sortChange.emit(this.field);
        // 触发全局事件
        // console.log("ListViewThComponent.onSortChange()", this.listView);
        this.listView.sortChange.emit(this.field);
    }

    onFilterChange() {
        // 触发当前字段事件
        this.filterChange.emit(this.field);
        // 触发全局事件
        // console.log("ListViewThComponent.onFilterChange()", this.listView);
        this.listView.filterChange.emit(this.field);
    }
}
